import './ui/styles.css';
import { renderHome } from './ui/app';

const app = document.getElementById('app');
if (!app) throw new Error('#app not found');
void renderHome(app);
